import { AssetAmount } from "../../ergo";
import { DefaultAmmOrdersParser } from "../parsers/ammOrdersParser";
import { DefaultAmmPoolsInfoParser } from "../parsers/ammPoolsInfoParser";
export function makeHistory(network) {
    const ordersParser = new DefaultAmmOrdersParser();
    const poolParser = new DefaultAmmPoolsInfoParser();
    return new NetworkHistory(network, ordersParser, poolParser);
}
export class NetworkHistory {
    constructor(network, ordersParser, poolsParser) {
        this.network = network;
        this.ordersParser = ordersParser;
        this.poolsParser = poolsParser;
    }
    async getAllByAddress(address, displayLatest) {
        const ops = [];
        let uOffset = 0;
        const limit = 100;
        while (ops.length < displayLatest) {
            const [txs, total] = await this.network.getUTxsByAddress(address, { offset: uOffset, limit: 100 });
            for (const tx of txs) {
                const op = this.parseOp(tx, false, [address]);
                if (op)
                    ops.push(op);
            }
            if (uOffset < total)
                uOffset += limit;
            else
                break;
        }
        let offset = 0;
        while (ops.length < displayLatest) {
            const [txs, total] = await this.network.getTxsByAddress(address, { offset, limit: 100 });
            for (const tx of txs) {
                const op = this.parseOp(tx, true, [address]);
                if (op)
                    ops.push(op);
            }
            if (offset < total)
                offset += limit;
            else
                break;
        }
        return ops;
    }
    async getAllByAddresses(addresses, displayLatest) {
        const ops = [];
        for (const addr of addresses) {
            let uOffset = 0;
            const limit = 100;
            while (ops.length < displayLatest) {
                const [txs, total] = await this.network.getUTxsByAddress(addr, { offset: uOffset, limit: 100 });
                for (const tx of txs) {
                    const op = this.parseOp(tx, false, addresses);
                    if (op)
                        ops.push(op);
                }
                if (uOffset < total)
                    uOffset += limit;
                else
                    break;
            }
            let offset = 0;
            while (ops.length < displayLatest) {
                const [txs, total] = await this.network.getTxsByAddress(addr, { offset, limit: 100 });
                for (const tx of txs) {
                    const op = this.parseOp(tx, true, addresses);
                    if (op)
                        ops.push(op);
                }
                if (offset < total)
                    offset += limit;
                else
                    break;
            }
        }
        return ops;
    }
    parseOp(tx, confirmed, addresses) {
        const outputOrder = tx.outputs
            .map(o => {
            const op = this.ordersParser.parse(o);
            return op ? [op, o] : undefined;
        })
            .find(x => x);
        if (outputOrder) {
            const [summary, output] = outputOrder;
            if (!output.spentTransactionId)
                return {
                    type: "order",
                    txId: tx.id,
                    boxId: output.boxId,
                    status: confirmed ? "submitted" : "pending",
                    order: summary
                };
        }
        const inputOrder = tx.inputs
            .map(o => {
            const op = this.ordersParser.parse(o);
            return op ? [op, o] : undefined;
        })
            .find(x => x);
        const poolOutput = () => tx.outputs.map(o => this.poolsParser.parse(o)).find(x => x);
        if (inputOrder) {
            const [summary, input] = inputOrder;
            const pool = poolOutput();
            if (pool) {
                return {
                    type: "order",
                    txId: tx.id,
                    boxId: input.boxId,
                    status: "executed",
                    order: summary
                };
            }
            else {
                return {
                    type: "refund",
                    txId: tx.id,
                    status: "executed",
                    operation: summary.type
                };
            }
        }
        const pool = poolOutput();
        if (pool) {
            const rewardLP = tx.outputs
                .filter(o => addresses.includes(o.address))
                .flatMap(o => o.assets)
                .find(a => a.tokenId === pool.lp.asset.id);
            if (rewardLP)
                return {
                    type: "setup",
                    txId: tx.id,
                    status: "executed",
                    pool: pool,
                    reward: AssetAmount.fromToken(rewardLP)
                };
        }
        return undefined;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGlzdG9yeS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9hbW0vcmVwb3NpdG9yaWVzL2hpc3RvcnkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFVLFdBQVcsRUFBQyxNQUFNLFlBQVksQ0FBQTtBQUcvQyxPQUFPLEVBQWtCLHNCQUFzQixFQUFDLE1BQU0sNEJBQTRCLENBQUE7QUFHbEYsT0FBTyxFQUFxQix5QkFBeUIsRUFBQyxNQUFNLCtCQUErQixDQUFBO0FBZ0IzRixNQUFNLFVBQVUsV0FBVyxDQUFDLE9BQW9CO0lBQzlDLE1BQU0sWUFBWSxHQUFHLElBQUksc0JBQXNCLEVBQUUsQ0FBQTtJQUNqRCxNQUFNLFVBQVUsR0FBRyxJQUFJLHlCQUF5QixFQUFFLENBQUE7SUFDbEQsT0FBTyxJQUFJLGNBQWMsQ0FBQyxPQUFPLEVBQUUsWUFBWSxFQUFFLFVBQVUsQ0FBQyxDQUFBO0FBQzlELENBQUM7QUFFRCxNQUFNLE9BQU8sY0FBYztJQUN6QixZQUNrQixPQUFvQixFQUNwQixZQUE2QixFQUM3QixXQUErQjtRQUYvQixZQUFPLEdBQVAsT0FBTyxDQUFhO1FBQ3BCLGlCQUFZLEdBQVosWUFBWSxDQUFpQjtRQUM3QixnQkFBVyxHQUFYLFdBQVcsQ0FBb0I7SUFDOUMsQ0FBQztJQUVKLEtBQUssQ0FBQyxlQUFlLENBQUMsT0FBZ0IsRUFBRSxhQUFxQjtRQUMzRCxNQUFNLEdBQUcsR0FBc0IsRUFBRSxDQUFBO1FBQ2pDLElBQUksT0FBTyxHQUFHLENBQUMsQ0FBQTtRQUNmLE1BQU0sS0FBSyxHQUFHLEdBQUcsQ0FBQTtRQUNqQixPQUFPLEdBQUcsQ0FBQyxNQUFNLEdBQUcsYUFBYSxFQUFFO1lBQ2pDLE1BQU0sQ0FBQyxHQUFHLEVBQUUsS0FBSyxDQUFDLEdBQUcsTUFBTSxJQUFJLENBQUMsT0FBTyxDQUFDLGdCQUFnQixDQUFDLE9BQU8sRUFBRSxFQUFDLE1BQU0sRUFBRSxPQUFPLEVBQUUsS0FBSyxFQUFFLEdBQUcsRUFBQyxDQUFDLENBQUE7WUFDaEcsS0FBSyxNQUFNLEVBQUUsSUFBSSxHQUFHLEVBQUU7Z0JBQ3BCLE1BQU0sRUFBRSxHQUFHLElBQUksQ0FBQyxPQUFPLENBQUMsRUFBRSxFQUFFLEtBQUssRUFBRSxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUE7Z0JBQzdDLElBQUksRUFBRTtvQkFBRSxHQUFHLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFBO2FBQ3JCO1lBQ0QsSUFBSSxPQUFPLEdBQUcsS0FBSztnQkFBRSxPQUFPLElBQUksS0FBSyxDQUFBOztnQkFDaEMsTUFBSztTQUNYO1FBQ0QsSUFBSSxNQUFNLEdBQUcsQ0FBQyxDQUFBO1FBQ2QsT0FBTyxHQUFHLENBQUMsTUFBTSxHQUFHLGFBQWEsRUFBRTtZQUNqQyxNQUFNLENBQUMsR0FBRyxFQUFFLEtBQUssQ0FBQyxHQUFHLE1BQU0sSUFBSSxDQUFDLE9BQU8sQ0FBQyxlQUFlLENBQUMsT0FBTyxFQUFFLEVBQUMsTUFBTSxFQUFFLEtBQUssRUFBRSxHQUFHLEVBQUMsQ0FBQyxDQUFBO1lBQ3RGLEtBQUssTUFBTSxFQUFFLElBQUksR0FBRyxFQUFFO2dCQUNwQixNQUFNLEVBQUUsR0FBRyxJQUFJLENBQUMsT0FBTyxDQUFDLEVBQUUsRUFBRSxJQUFJLEVBQUUsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFBO2dCQUM1QyxJQUFJLEVBQUU7b0JBQUUsR0FBRyxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQTthQUNyQjtZQUNELElBQUksTUFBTSxHQUFHLEtBQUs7Z0JBQUUsTUFBTSxJQUFJLEtBQUssQ0FBQTs7Z0JBQzlCLE1BQUs7U0FDWDtRQUNELE9BQU8sR0FBRyxDQUFBO0lBQ1osQ0FBQztJQUVELEtBQUssQ0FBQyxpQkFBaUIsQ0FBQyxTQUFvQixFQUFFLGFBQXFCO1FBQ2pFLE1BQU0sR0FBRyxHQUFzQixFQUFFLENBQUE7UUFDakMsS0FBSyxNQUFNLElBQUksSUFBSSxTQUFTLEVBQUU7WUFDNUIsSUFBSSxPQUFPLEdBQUcsQ0FBQyxDQUFBO1lBQ2YsTUFBTSxLQUFLLEdBQUcsR0FBRyxDQUFBO1lBQ2pCLE9BQU8sR0FBRyxDQUFDLE1BQU0sR0FBRyxhQUFhLEVBQUU7Z0JBQ2pDLE1BQU0sQ0FBQyxHQUFHLEVBQUUsS0FBSyxDQUFDLEdBQUcsTUFBTSxJQUFJLENBQUMsT0FBTyxDQUFDLGdCQUFnQixDQUFDLElBQUksRUFBRSxFQUFDLE1BQU0sRUFBRSxPQUFPLEVBQUUsS0FBSyxFQUFFLEdBQUcsRUFBQyxDQUFDLENBQUE7Z0JBQzdGLEtBQUssTUFBTSxFQUFFLElBQUksR0FBRyxFQUFFO29CQUNwQixNQUFNLEVBQUUsR0FBRyxJQUFJLENBQUMsT0FBTyxDQUFDLEVBQUUsRUFBRSxLQUFLLEVBQUUsU0FBUyxDQUFDLENBQUE7b0JBQzdDLElBQUksRUFBRTt3QkFBRSxHQUFHLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFBO2lCQUNyQjtnQkFDRCxJQUFJLE9BQU8sR0FBRyxLQUFLO29CQUFFLE9BQU8sSUFBSSxLQUFLLENBQUE7O29CQUNoQyxNQUFLO2FBQ1g7WUFDRCxJQUFJLE1BQU0sR0FBRyxDQUFDLENBQUE7WUFDZCxPQUFPLEdBQUcsQ0FBQyxNQUFNLEdBQUcsYUFBYSxFQUFFO2dCQUNqQyxNQUFNLENBQUMsR0FBRyxFQUFFLEtBQUssQ0FBQyxHQUFHLE1BQU0sSUFBSSxDQUFDLE9BQU8sQ0FBQyxlQUFlLENBQUMsSUFBSSxFQUFFLEVBQUMsTUFBTSxFQUFFLEtBQUssRUFBRSxHQUFHLEVBQUMsQ0FBQyxDQUFBO2dCQUNuRixLQUFLLE1BQU0sRUFBRSxJQUFJLEdBQUcsRUFBRTtvQkFDcEIsTUFBTSxFQUFFLEdBQUcsSUFBSSxDQUFDLE9BQU8sQ0FBQyxFQUFFLEVBQUUsSUFBSSxFQUFFLFNBQVMsQ0FBQyxDQUFBO29CQUM1QyxJQUFJLEVBQUU7d0JBQUUsR0FBRyxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQTtpQkFDckI7Z0JBQ0QsSUFBSSxNQUFNLEdBQUcsS0FBSztvQkFBRSxNQUFNLElBQUksS0FBSyxDQUFBOztvQkFDOUIsTUFBSzthQUNYO1NBQ0Y7UUFDRCxPQUFPLEdBQUcsQ0FBQTtJQUNaLENBQUM7SUFFTyxPQUFPLENBQUMsRUFBYSxFQUFFLFNBQWtCLEVBQUUsU0FBb0I7UUFDckUsTUFBTSxXQUFXLEdBQUcsRUFBRSxDQUFDLE9BQU87YUFDM0IsR0FBRyxDQUFDLENBQUMsQ0FBQyxFQUFFO1lBQ1AsTUFBTSxFQUFFLEdBQUcsSUFBSSxDQUFDLFlBQVksQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUE7WUFDckMsT0FBTyxFQUFFLENBQUMsQ0FBQyxDQUFFLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBZ0MsQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFBO1FBQ2pFLENBQUMsQ0FBQzthQUNELElBQUksQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFBO1FBQ2YsSUFBSSxXQUFXLEVBQUU7WUFDZixNQUFNLENBQUMsT0FBTyxFQUFFLE1BQU0sQ0FBQyxHQUFHLFdBQVcsQ0FBQTtZQUNyQyxJQUFJLENBQUMsTUFBTSxDQUFDLGtCQUFrQjtnQkFDNUIsT0FBTztvQkFDTCxJQUFJLEVBQUUsT0FBTztvQkFDYixJQUFJLEVBQUUsRUFBRSxDQUFDLEVBQUU7b0JBQ1gsS0FBSyxFQUFFLE1BQU0sQ0FBQyxLQUFLO29CQUNuQixNQUFNLEVBQUUsU0FBUyxDQUFDLENBQUMsQ0FBQyxXQUFXLENBQUMsQ0FBQyxDQUFDLFNBQVM7b0JBQzNDLEtBQUssRUFBRSxPQUFPO2lCQUNmLENBQUE7U0FDSjtRQUVELE1BQU0sVUFBVSxHQUFHLEVBQUUsQ0FBQyxNQUFNO2FBQ3pCLEdBQUcsQ0FBQyxDQUFDLENBQUMsRUFBRTtZQUNQLE1BQU0sRUFBRSxHQUFHLElBQUksQ0FBQyxZQUFZLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFBO1lBQ3JDLE9BQU8sRUFBRSxDQUFDLENBQUMsQ0FBRSxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQWdDLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQTtRQUNqRSxDQUFDLENBQUM7YUFDRCxJQUFJLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBQTtRQUVmLE1BQU0sVUFBVSxHQUFHLEdBQUcsRUFBRSxDQUFDLEVBQUUsQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLFdBQVcsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBQTtRQUVwRixJQUFJLFVBQVUsRUFBRTtZQUNkLE1BQU0sQ0FBQyxPQUFPLEVBQUUsS0FBSyxDQUFDLEdBQUcsVUFBVSxDQUFBO1lBQ25DLE1BQU0sSUFBSSxHQUFHLFVBQVUsRUFBRSxDQUFBO1lBQ3pCLElBQUksSUFBSSxFQUFFO2dCQUNSLE9BQU87b0JBQ0wsSUFBSSxFQUFFLE9BQU87b0JBQ2IsSUFBSSxFQUFFLEVBQUUsQ0FBQyxFQUFFO29CQUNYLEtBQUssRUFBRSxLQUFLLENBQUMsS0FBSztvQkFDbEIsTUFBTSxFQUFFLFVBQVU7b0JBQ2xCLEtBQUssRUFBRSxPQUFPO2lCQUNmLENBQUE7YUFDRjtpQkFBTTtnQkFDTCxPQUFPO29CQUNMLElBQUksRUFBRSxRQUFRO29CQUNkLElBQUksRUFBRSxFQUFFLENBQUMsRUFBRTtvQkFDWCxNQUFNLEVBQUUsVUFBVTtvQkFDbEIsU0FBUyxFQUFFLE9BQU8sQ0FBQyxJQUFJO2lCQUN4QixDQUFBO2FBQ0Y7U0FDRjtRQUVELE1BQU0sSUFBSSxHQUFHLFVBQVUsRUFBRSxDQUFBO1FBQ3pCLElBQUksSUFBSSxFQUFFO1lBQ1IsTUFBTSxRQUFRLEdBQUcsRUFBRSxDQUFDLE9BQU87aUJBQ3hCLE1BQU0sQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDLFNBQVMsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxDQUFDO2lCQUMxQyxPQUFPLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDO2lCQUN0QixJQUFJLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsT0FBTyxLQUFLLElBQUksQ0FBQyxFQUFFLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQyxDQUFBO1lBQzVDLElBQUksUUFBUTtnQkFDVixPQUFPO29CQUNMLElBQUksRUFBRSxPQUFPO29CQUNiLElBQUksRUFBRSxFQUFFLENBQUMsRUFBRTtvQkFDWCxNQUFNLEVBQUUsVUFBVTtvQkFDbEIsSUFBSSxFQUFFLElBQUk7b0JBQ1YsTUFBTSxFQUFFLFdBQVcsQ0FBQyxTQUFTLENBQUMsUUFBUSxDQUFDO2lCQUN4QyxDQUFBO1NBQ0o7UUFFRCxPQUFPLFNBQVMsQ0FBQTtJQUNsQixDQUFDO0NBQ0YifQ==